var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketDiscountInactive = function SvgTicketDiscountInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.375 11.458a2.29 2.29 0 0 1 2.292-2.292V8.25c0-3.667-.917-4.583-4.584-4.583H6.918c-3.667 0-4.583.916-4.583 4.583v.458a2.292 2.292 0 0 1 0 4.583v.459c0 3.666.916 4.583 4.583 4.583h9.167c3.666 0 4.583-.916 4.583-4.583a2.29 2.29 0 0 1-2.292-2.292M8.75 13.521l5.5-5.5M14.245 13.52h.008M8.745 8.48h.008"
  })));
};
export default SvgTicketDiscountInactive;